module.exports = __webpack_public_path__ + "img/female-avatar.2c2b2b01.png";